enum GivexApiServer {
  SANDBOX = 1,
  BETA = 2,
  US_PRODUCTION = 3,
  CANADA_PRODUCTION = 4,
}

export { GivexApiServer };
